/**
 * Created by gilk on 08/08/17.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("user-management-templates/skills/customSettingsSLAOptionView.tmpl");
    var Dropdown = require("ui/dropdown/Dropdown");
    var InputField = require("ui/input-field/InputField");
    var TimeUtils = require("reporting-assets/js/TimeUtils");

    var CustomSettingsSLAOptionView = {};

    LE.module("LEUserManagement", function (LEUserManagement, LE, Backbone, Marionette, $, _) {
        CustomSettingsSLAOptionView = Marionette.ItemView.extend({
            template : template,
            className: "sla-custom-settings-container",
            ui: {
                slaEditContainer: ".sla-edit-container",
                slaDefaultInput: ".default-sla-container .default-value-container",
                slaDefaultDropdown: ".default-sla-container .default-dropdown-container",
                slaUrgentInput: ".urgent-sla-container .urgent-value-container",
                slaUrgentDropdown: ".urgent-sla-container .urgent-dropdown-container",
                slaFirstTimeInput: ".first-time-sla-container .first-time-value-container",
                slaFirstTimeDropdown: ".first-time-sla-container .first-time-dropdown-container"
            },
            uiComponents: {
                defaultSlaUnitsDropDown: {
                    type: Dropdown,
                    options: {
                        container: "view.ui.slaDefaultDropdown",
                        items: "view._getSlaUnitsOptions",
                        permutation: Dropdown.PERMUTATION.XX_SMALL1,
                        selectedOption: "view._getSelectedDefaultSlaUnits"
                    },
                    events: {
                        change: "_onDefaultUnitChange"
                    }
                },
                urgentSlaUnitsDropDown: {
                    type: Dropdown,
                    options: {
                        container: "view.ui.slaUrgentDropdown",
                        items: "view._getSlaUnitsOptions",
                        permutation: Dropdown.PERMUTATION.XX_SMALL1,
                        selectedOption: "view._getSelectedUrgentSlaUnits"
                    },
                    events: {
                        change: "_onUrgentUnitChange"
                    }
                },
                firstTimeSlaUnitsDropDown: {
                    type: Dropdown,
                    options: {
                        container: "view.ui.slaFirstTimeDropdown",
                        items: "view._getSlaUnitsOptions",
                        permutation: Dropdown.PERMUTATION.XX_SMALL1,
                        selectedOption: "view._getSelectedFirstTimeSlaUnits"
                    },
                    events: {
                        change: "_onFirstTimeUnitChange"
                    }
                },
                defaultSlaInput: {
                    type: InputField,
                    options: {
                        el: "view.ui.slaDefaultInput",
                        permutation: InputField.Permutation.K,
                        maxLength: 4,
                        inputType: InputField.prototype.InputTypeEnum.NaturalNumber,
                        value: "view._getSelectedDefaultSla"
                    },
                    events: {
                        change: "_onDefaultSlaChange"
                    }
                },
                urgentSlaInput: {
                    type: InputField,
                    options: {
                        el: "view.ui.slaUrgentInput",
                        permutation: InputField.Permutation.K,
                        maxLength: 4,
                        inputType: InputField.prototype.InputTypeEnum.NaturalNumber,
                        value: "view._getSelectedUrgentSla"
                    },
                    events: {
                        change: "_onUrgentSlaChange"
                    }
                },
                firstTimeSlaInput: {
                    type: InputField,
                    options: {
                        el: "view.ui.slaFirstTimeInput",
                        permutation: InputField.Permutation.K,
                        maxLength: 4,
                        inputType: InputField.prototype.InputTypeEnum.NaturalNumber,
                        value: "view._getSelectedFirstTimeSla"
                    },
                    events: {
                        change: "_onFirstTimeSlaChange"
                    }
                }
            },

            initialize: function(options) {
                this.channel = options.channel;
            },

            onRender: function() {
                this.toggleCustomConfigurationVisibility();
            },

            toggleCustomConfigurationVisibility: function() {
                var show = !!(this.model.getSlaDefaultResponseTime() && this.model.getSlaUrgentResponseTime() && this.model.getSlaFirstTimeResponseTime());
                this.ui.slaEditContainer.toggleClass("hide", !show);
            },

            updateDefaultSlaTime: function(defaultResponseTimeInSeconds) {
                var slaValue = this._getSlaValueFromSeconds(defaultResponseTimeInSeconds);

                this.uiComponents.defaultSlaInput.setValue(slaValue.slaInUnit);
                this.uiComponents.defaultSlaUnitsDropDown.setSelection(slaValue.slaTimeUnit);
            },

            updateUrgentSlaTime: function(urgentResponseTimeInSeconds) {
                var slaValue = this._getSlaValueFromSeconds(urgentResponseTimeInSeconds);

                this.uiComponents.urgentSlaInput.setValue(slaValue.slaInUnit);
                this.uiComponents.urgentSlaUnitsDropDown.setSelection(slaValue.slaTimeUnit);
            },

            updateFirstTimeSlaTime: function(firstTimeResponseTimeInSeconds) {
                var slaValue = this._getSlaValueFromSeconds(firstTimeResponseTimeInSeconds);


                this.uiComponents.firstTimeSlaInput.setValue(slaValue.slaInUnit);
                this.uiComponents.firstTimeSlaUnitsDropDown.setSelection(slaValue.slaTimeUnit);
            },

            _getSlaValueFromSeconds: function(responseTimeInSeconds) {
                var slaInUnit = TimeUtils.convertSecondsToDaysHoursAndMinutes(responseTimeInSeconds);
                slaInUnit = slaInUnit.days ||  slaInUnit.hours || slaInUnit.minutes;
                var slaTimeUnit = TimeUtils.getSlaTimeUnitFromSeconds(responseTimeInSeconds);
                return {
                    slaInUnit: slaInUnit ? slaInUnit : "",
                    slaTimeUnit: slaTimeUnit
                };
            },

            _getSlaUnitsOptions: function() {
                var slaUnitsList = LE.siteSettings.SlaUnitsSettings.getSlaUnitsListTranslated();
                return new Dropdown.Collection(slaUnitsList);
            },

            _getSelectedDefaultSlaUnits: function() {
                var slaInSeconds = this.model.getSlaDefaultResponseTime();
                return TimeUtils.getSlaTimeUnitFromSeconds(slaInSeconds);
            },

            _getSelectedUrgentSlaUnits: function() {
                var slaInSeconds = this.model.getSlaUrgentResponseTime();
                return TimeUtils.getSlaTimeUnitFromSeconds(slaInSeconds);
            },

            _getSelectedFirstTimeSlaUnits: function() {
                var slaInSeconds = this.model.getSlaFirstTimeResponseTime();
                return TimeUtils.getSlaTimeUnitFromSeconds(slaInSeconds);
            },

            _getSelectedDefaultSla: function() {
                var slaInSeconds = this.model.getSlaDefaultResponseTime();
                var slaInUnit = TimeUtils.convertSecondsToDaysHoursAndMinutes(slaInSeconds);
                slaInUnit = slaInUnit.days ||  slaInUnit.hours || slaInUnit.minutes;
                return slaInUnit ? slaInUnit : "";
            },

            _getSelectedUrgentSla: function() {
                var slaInSeconds = this.model.getSlaUrgentResponseTime();
                var slaInUnit = TimeUtils.convertSecondsToDaysHoursAndMinutes(slaInSeconds);
                slaInUnit = slaInUnit.days ||  slaInUnit.hours || slaInUnit.minutes;
                return slaInUnit ? slaInUnit : "";
            },

            _getSelectedFirstTimeSla: function() {
                var slaInSeconds = this.model.getSlaFirstTimeResponseTime();
                var slaInUnit = TimeUtils.convertSecondsToDaysHoursAndMinutes(slaInSeconds);
                slaInUnit = slaInUnit.days ||  slaInUnit.hours || slaInUnit.minutes;
                return slaInUnit ? slaInUnit : "";
            },

            _onDefaultSlaChange: function(componentId, eventName, value) {
                var defaultSlaValues = {
                    timeValue: value,
                    timeUnit: this.uiComponents.defaultSlaUnitsDropDown.getValue()
                };
                this.channel.trigger("skill:sla:default:change", defaultSlaValues);
            },

            _onUrgentSlaChange: function(componentId, eventName, value) {
                var urgentSlaValues = {
                    timeValue: value,
                    timeUnit: this.uiComponents.urgentSlaUnitsDropDown.getValue()
                };
                this.channel.trigger("skill:sla:urgent:change", urgentSlaValues);
            },

            _onFirstTimeSlaChange: function(componentId, eventName, value) {
                var firstTimeSlaValues = {
                    timeValue: value,
                    timeUnit: this.uiComponents.firstTimeSlaUnitsDropDown.getValue()
                };
                this.channel.trigger("skill:sla:firstTime:change", firstTimeSlaValues);
            },

            _onDefaultUnitChange: function(componentId, eventName, slaUnit) {
                var defaultSlaValues = {
                    timeValue: this.uiComponents.defaultSlaInput.getValue(),
                    timeUnit: slaUnit.selectedKey
                };
                this.channel.trigger("skill:sla:default:change", defaultSlaValues);
            },

            _onUrgentUnitChange: function(componentId, eventName, slaUnit) {
                var urgentSlaValues = {
                    timeValue: this.uiComponents.urgentSlaInput.getValue(),
                    timeUnit: slaUnit.selectedKey
                };
                this.channel.trigger("skill:sla:urgent:change", urgentSlaValues);
            },

            _onFirstTimeUnitChange: function(componentId, eventName, slaUnit) {
                var firstTimeSlaValues = {
                    timeValue: this.uiComponents.firstTimeSlaInput.getValue(),
                    timeUnit: slaUnit.selectedKey
                };
                this.channel.trigger("skill:sla:firstTime:change", firstTimeSlaValues);
            },

            onClose: function() {
                LEUserManagement.logger.debug("onClose", "CustomSettingsSLAOptionView:onClose");
            }
        });
    });

    return CustomSettingsSLAOptionView;
});
